import { useMediaQuery, useTheme } from '@mui/material'

// Shared "is this a phone-sized viewport?" hook so every page agrees on the
// same breakpoint. `md` (900px) is the cut-off: below it the sidebar is a
// temporary drawer and desktop table/toolbars need to stack.
//
//   const isMobile = useIsMobile()          // < 900px
//   const isPhone = useIsMobile('sm')       // < 600px
const useIsMobile = (breakpoint = 'md') => {
  const theme = useTheme()
  // noSsr: the app is pure CSR, so evaluate matchMedia on the first render.
  // Without it the hook returns false for one render and flips after mount —
  // anything initialising state from it (e.g. "start with the menu closed on
  // phones") captures the wrong value.
  return useMediaQuery(theme.breakpoints.down(breakpoint), { noSsr: true })
}

export default useIsMobile
